import { GET, POST } from "../../Methods";
import { APIS } from "../../APIS";
import { IDS } from "../../IDS";

export const PlaceBets = async (data) => {
  return await POST(APIS.Bets.Place, data);
};

export const CancelledBets = async (id, data = {}) => {
  return await POST(`${APIS.Bets.Cancelled}/${id}`, data);
};

export const Calculations = async (data) => {
  return await POST(APIS.Bets.Calculations, data);
};

export const LiveBets = async () => {
  return await GET(APIS.Bets.LiveBets);
};

export const UnmatchBets = async () => {
  return await GET(APIS.Bets.UnmatchBets);
};

// export const LiveBetsAmount = async () => {
//   return await GET(APIS.Bets.LiveBetsAmount);
// };

export const LiveBetsAmount = async (matche_id) => {
  return await GET(`${APIS.Bets.LiveBetsAmount}?matche_id=${matche_id || ""}`);
};

export const AllCompletedBets = async (filter) => {
  return await GET(
    `${APIS.Bets.CompletedBets}?s_date=${filter?.s_date ||
      ""}&e_date=${filter?.e_date || ""}&page=${filter?.page ||
      IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
  );
  // return await GET(APIS.Bets.CompletedBets);
};

export const BookShowBets = async (filter) => {
  return await GET(
    `${APIS.Bets.BookShowBets}?type_id=${filter?.type_id ||
      ""}&matche_id=${filter?.matche_id || ""}&runner_id=${filter?.runner_id ||
      ""}`,
  );
};

export const Jackpot = async (filter) => {
  return await GET(`${APIS.Bets.Jackpot}?runner_id=${filter?.runner_id || ""}`);
};

export const BetButtons = async () => {
  return await GET(APIS.Bets.BetButtons);
};
